export default "__VITE_ASSET__354e1976__"